import React, { useCallback } from 'react';

import { QButton, QEmptyState, QEmptyStateButtonGroup, QEmptyStateSecondaryButtonGroup } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router-dom';

const SuppliersInsufficientPermissionsView: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const showProductVideo = useCallback(() => {
    navigate('/product-video');
  }, [navigate]);
  return (
    <>
      <div data-cy={'suppliers-insufficient-permissions'}>
        <QEmptyState
          title={t('upSellViews.insufficientPermissions.title')}
          subtitle={t('upSellViews.insufficientPermissions.subtitle')}
        >
          <QEmptyStateButtonGroup>
            <QEmptyStateSecondaryButtonGroup>
              <QButton variant="outline" onClick={showProductVideo}>
                {t('upSellViews.insufficientPermissions.button')}
              </QButton>
            </QEmptyStateSecondaryButtonGroup>
          </QEmptyStateButtonGroup>
        </QEmptyState>
        <Outlet />
      </div>
    </>
  );
};

export default SuppliersInsufficientPermissionsView;
